export default "__VITE_ASSET__ChcfGfQK__"